import { unwrapEnvelope } from "../../../utils/api/unwrap-envelope.ts"
import { jsonBody } from "./bytes.ts"
import type { Outcome } from "./types.ts"

const text = (value: unknown) => (typeof value === "string" ? value : null)

const firstFieldMessage = (body: Record<string, unknown>) => {
  for (const value of Object.values(body)) {
    if (Array.isArray(value) && typeof value[0] === "string") return value[0]
    if (typeof value === "string") return value
  }
  return null
}

const asRecord = (body: unknown): Record<string, unknown> =>
  body && typeof body === "object"
    ? Object.fromEntries(Object.entries(body))
    : {}

export const refusedWith = <T>(status: number, body: unknown): Outcome<T> => {
  const record = asRecord(body)
  return {
    ok: false,
    status,
    data: null,
    reason: text(record.reason),
    detail: text(record.detail) ?? firstFieldMessage(record)
  }
}

export const accepted = <T>(status: number, data: T): Outcome<T> => ({
  ok: true,
  status,
  data,
  reason: null,
  detail: null
})

export const toOutcome = <T>(status: number, body: unknown): Outcome<T> =>
  status >= 200 && status < 300
    ? accepted(status, unwrapEnvelope<T>(body))
    : refusedWith<T>(status, body)

// Anything but the picture is a refusal, whatever its status.
export const markOutcome = async (
  status: number,
  data: unknown
): Promise<Outcome<Blob>> =>
  status === 200 && data instanceof Blob
    ? accepted(status, data)
    : refusedWith<Blob>(status, await jsonBody(data))
